import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Observe } from 'rewire-core';
import authService from '../services/AuthService';

export function PrivateRoute({ component: Component, ...rest }: any): JSX.Element {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Observe
          render={() =>
            authService.isAuthenticated ? (
              <Component {...props} />
            ) : (
              <Redirect to={{ pathname: authService.loginRedirectUrl, state: { from: props.location } }} />
            )
          }
        />
      )}
    />
  );
}

// export class PrivateRoute extends React.Component {
//   constructor(props) {
//     super(props);
//   }

//   render() {
//     const {component: Component, ...rest} = this.props;

//     return (
//       <Route {...rest} render={(props) => (
//         authService.isAuthenticated
//           ? <Component {...props} />
//           : <Redirect to={{pathname: Routes.Login, state: {from: props.location}}} />
//       )} />
//     );
//   }
// }

// export default PrivateRoute;
